import { INPUT_METHOD } from '@atlaskit/editor-common/analytics/types/enums';
import type { EditorCommand } from '@atlaskit/editor-common/types/editor-command';
import { linkifyContent } from '@atlaskit/editor-common/utils/hyperlink';
import type { Transaction } from '@atlaskit/editor-prosemirror/state';

type QueueCardsFromRange = (
	from: number,
	to: number,
	source: INPUT_METHOD.TYPEAHEAD,
) => EditorCommand;

/**
 * Mirrors plain-text paste for programmatically inserted text: URLs get link marks,
 * then the card plugin resolves them into smart links. Text content and length are unchanged.
 */
export const linkifyInsertedText = (
	tr: Transaction,
	from: number,
	to: number,
	queueCardsFromRange: QueueCardsFromRange | undefined,
): Transaction => {
	const slice = tr.doc.slice(from, to);
	const linkified = linkifyContent(tr.doc.type.schema)(slice);
	if (linkified.eq(slice)) {
		return tr;
	}
	tr.replace(from, to, linkified);
	return queueCardsFromRange?.(from, to, INPUT_METHOD.TYPEAHEAD)({ tr }) ?? tr;
};
